// Compression des photos dans le navigateur avant l'envoi : JPEG 1600 px max
// (lisible, ~200-400 Ko) + miniature 360 px pour les listes.
async function decoder(file) {
  if (window.createImageBitmap) {
    try { return await createImageBitmap(file, { imageOrientation: "from-image" }); } catch { /* repli <img> */ }
  }
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    img.src = url;
    await img.decode();
    return img;
  } finally { URL.revokeObjectURL(url); }
}

function versJpeg(src, max, qualite) {
  const w = src.width, h = src.height;
  const k = Math.min(1, max / Math.max(w, h));
  const c = document.createElement("canvas");
  c.width = Math.max(1, Math.round(w * k));
  c.height = Math.max(1, Math.round(h * k));
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, c.width, c.height);
  ctx.drawImage(src, 0, 0, c.width, c.height);
  return new Promise((ok, ko) => c.toBlob((b) => (b ? ok(b) : ko(new Error("compression"))), "image/jpeg", qualite));
}

export async function compresserPhoto(file) {
  let src;
  try { src = await decoder(file); } catch { throw new Error(`« ${file.name} » n'est pas une image lisible.`); }
  const [full, mini] = await Promise.all([versJpeg(src, 1600, 0.82), versJpeg(src, 360, 0.7)]);
  src.close?.();
  return { full, mini };
}

/** Envoie une photo (compressée) sur la fiche colis. */
export async function envoyerPhoto(api, colisId, file, { instanceId = null, legende = "" } = {}) {
  const { full, mini } = await compresserPhoto(file);
  const fd = new FormData();
  fd.append("file", full, "photo.jpg");
  fd.append("mini", mini, "mini.jpg");
  if (instanceId) fd.append("instance_id", instanceId);
  if (legende) fd.append("legende", legende);
  const { data } = await api.post(`/colis/${colisId}/photos`, fd);
  return data;
}
